import styled, { css } from 'styled-components';

export const SectionWrapper = styled.div(
  () => css`
    grid-area: faq;
  `,
);

export const Heading = styled.h1(
  ({ theme }) => css`
    margin: 0;
    color: ${theme.co.secondary20};
    text-align: center;
    ${theme.typography.heading.desktop.l};
    margin-bottom: ${theme.sz.s10};

    @media (max-width: ${theme.sz.lg}) {
      ${theme.typography.heading.mobile.m};
      margin-bottom: ${theme.sz.s6};
    }
  `,
);
export const Questions = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.sz.s5};

    @media (max-width: ${theme.sz.md}) {
      gap: ${theme.sz.s2};
    }
  `,
);
